/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Tonnes_100Inputs */

const en_us2_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 tonnes`)
};

const pt_br2_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 toneladas`)
};

const es_419_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 toneladas`)
};

const pt_pt2_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 toneladas`)
};

const fr_fr2_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 tonnes`)
};

const de_de2_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 Tonnen`)
};

const it_it2_achievement_tonnes_100 = /** @type {(inputs: Achievement_Tonnes_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 tonnellate`)
};

/**
* | output |
* | --- |
* | "100 tonnes" |
*
* @param {Achievement_Tonnes_100Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_tonnes_100 = /** @type {((inputs?: Achievement_Tonnes_100Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Tonnes_100Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_tonnes_100(inputs)
	if (locale === "es-419") return es_419_achievement_tonnes_100(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_tonnes_100(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_tonnes_100(inputs)
	if (locale === "de-DE") return de_de2_achievement_tonnes_100(inputs)
	if (locale === "it-IT") return it_it2_achievement_tonnes_100(inputs)
	return en_us2_achievement_tonnes_100(inputs)
});
export { achievement_tonnes_100 as "achievement.tonnes_100" }